module.exports = __webpack_public_path__ + "img/lg_ring_y_0_0_null@2x.e4e069fd.png";